// extracted by mini-css-extract-plugin
export default {"container":"Subtitles_container__cWiWd"};